export const updateChatAction = "updateChatAction";
export const userDetailAction = "userDetailAction";
export const activeChatAction = "activeChatAction";
export const activeChatUserAction = "activeChatUserAction";
export const triggerRefreshUserListAction = "triggerRefreshUserListAction";